import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";

/** Menu di navigazione mobile: barra in alto con icone ed etichetta breve, tendina delle voci. */
export function MenuMobile({ sezioni, sempreVisibile }) {
  const [aperta, setAperta] = useState(null);
  const [voceAperta, setVoceAperta] = useState(null);
  const { pathname } = useLocation();
  const sezione = sezioni.find((s) => s.key === aperta);

  return (
    <div className={`${sempreVisibile ? "" : "lg:hidden"} sticky top-16 z-20 bg-white
      border-b border-slate-200`} data-testid="menu-mobile">
      <div className="flex items-stretch overflow-x-auto no-scrollbar">
        {sezioni.map((s) => {
          const attiva = s.to
            ? pathname === s.to || pathname.startsWith(`${s.to}/`)
            : (s.voci || []).some((v) => pathname === v.to);
          const cls = `flex-1 min-w-[80px] flex flex-col items-center gap-1 pt-2.5 pb-2 border-b-2
            transition-colors duration-200 ${attiva || aperta === s.key
              ? "border-[#0018A8] text-[#0018A8]" : "border-transparent text-slate-400"}`;
          const breve = s.breve || s.label.split(" ")[0];
          const etichetta = (
            <span className="text-[10px] leading-none font-semibold truncate max-w-[80px]"
              data-testid={`menu-mobile-label-${s.key}`}>{breve}</span>
          );
          return s.to ? (
            <NavLink key={s.key} to={s.to} title={s.label} className={cls}
              data-testid={`menu-mobile-${s.key}`} onClick={() => setAperta(null)}>
              <s.icon size={20} />
              {etichetta}
            </NavLink>
          ) : (
            <button key={s.key} type="button" title={s.label} className={cls}
              data-testid={`menu-mobile-${s.key}`}
              onClick={() => setAperta((v) => (v === s.key ? null : s.key))}>
              <s.icon size={20} />
              {etichetta}
            </button>
          );
        })}
      </div>
      {sezione && (
        <div className="border-t border-slate-100 bg-slate-50 px-3 py-2 space-y-1"
          data-testid={`menu-mobile-voci-${sezione.key}`}>
          <div className="flex items-center gap-2 px-2 pb-1 text-[10px] uppercase tracking-[0.16em] text-slate-400">
            {sezione.label}
            <ChevronDown size={12} className="rotate-180" />
          </div>
          {(sezione.voci || []).map((v) => (v.sotto ? (
            <div key={v.testid}>
              <button type="button" data-testid={`menu-mobile-voce-${v.testid}`}
                onClick={() => setVoceAperta((x) => (x === v.testid ? null : v.testid))}
                className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-left
                  transition-colors duration-200 ${voceAperta === v.testid
                    ? "bg-white text-slate-900 font-medium" : "text-slate-600"}`}>
                <span className="truncate">{v.label}</span>
                <ChevronDown size={14} className={`ml-auto shrink-0 transition-transform duration-200
                  ${voceAperta === v.testid ? "rotate-180" : "-rotate-90"}`} />
              </button>
              {voceAperta === v.testid && (
                <div className="ml-3 pl-3 border-l border-slate-200 space-y-1 mt-1"
                  data-testid={`menu-mobile-sotto-${v.testid}`}>
                  {v.sotto.map((w) => (
                    <NavLink key={w.to} to={w.to} end={w.exact}
                      onClick={() => { setAperta(null); setVoceAperta(null); }}
                      data-testid={`menu-mobile-voce-${w.testid}`}
                      className={({ isActive }) => `block px-3 py-2 rounded-md text-sm transition-colors duration-200
                        ${isActive ? "bg-white text-slate-900 font-medium" : "text-slate-500"}`}>
                      {w.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <NavLink key={v.to} to={v.to} end={v.exact} onClick={() => setAperta(null)}
              data-testid={`menu-mobile-voce-${v.testid || v.to}`}
              className={({ isActive }) => `block px-3 py-2 rounded-md text-sm transition-colors duration-200
                ${isActive ? "bg-white text-slate-900 font-medium" : "text-slate-600"}`}>
              {v.label}
            </NavLink>
          )))}
          {!(sezione.voci || []).length && (
            <div className="px-3 py-2 text-xs text-slate-400">Nessuna pagina</div>
          )}
        </div>
      )}
    </div>
  );
}
